import { imageAdapter as baseImageAdapter } from '@apester/image';

// @apester/image's adapter factory + mediaTypePathMap only know these providers. Any other
// provider (e.g. pexels) is an absolute external-CDN URL that renders via the unsplash adapter
// (direct serve + size params). Unknown providers are mapped here so no render path hands the
// factory a type it can't construct (`new adapters[TYPE]()` -> not a constructor). Known types map
// to themselves (identity) -> existing renders are byte-identical. Mapped on a copy so credit,
// which reads the raw image.type separately, is untouched.
const FACTORY_PROVIDERS = ['giphy', 'cdn', 'unsplash', 'youtube'];

// Strip video covers carry provider "youtubeVideo" (interactionDataExtractor); alias to the youtube
// adapter so the real thumbnail renders from data.path, not a fallthrough to unsplash on the bare videoId.
const PROVIDER_ALIASES = { youtubevideo: 'youtube' };

const toRenderType = (type) => {
  if (!type) return 'unsplash';
  const lower = type.toLowerCase();
  return PROVIDER_ALIASES[lower] || (FACTORY_PROVIDERS.includes(lower) ? type : 'unsplash');
};

// Drop-in wrapper for @apester/image's imageAdapter. The factory reads the provider from
// element.data.type, and the poll/quiz path also reads it (+ the url field) from element.oldModel,
// so both are mapped.
function imageAdapter(element, quality) {
  if (element && element.data && element.data.type) {
    const mapped = {
      ...element,
      data: { ...element.data, type: toRenderType(element.data.type) },
    };
    if (element.oldModel && element.oldModel.type) {
      mapped.oldModel = { ...element.oldModel, type: toRenderType(element.oldModel.type) };
    }
    return baseImageAdapter(mapped, quality);
  }
  return baseImageAdapter(element, quality);
}

export { imageAdapter, toRenderType };
